import { render, staticRenderFns } from "./copy-class.vue?vue&type=template&id=4b255e29"
import script from "./copy-class.vue?vue&type=script&lang=js"
export * from "./copy-class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports